import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";

interface ApiPaginationProps {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  onPageChange: (page: number) => void;
}

const ApiPagination = ({ currentPage, totalPages, totalItems, itemsPerPage, hasNextPage, hasPreviousPage, onPageChange }: ApiPaginationProps) => {
  /**
   * get visible pages for pagination
   */
  const getVisiblePages = (current: number, total: number): number[] => {
    if (total < 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    } else {
      if (current % 5 >= 0 && current > 4 && current + 2 < total) {
        return [1, current - 1, current, current + 1, total];
      } else if (current % 5 >= 0 && current > 4 && current + 2 >= total) {
        return [1, total - 3, total - 2, total - 1, total];
      } else {
        return [1, 2, 3, 4, 5, total];
      }
    }
  };

  const visiblePages = getVisiblePages(currentPage, totalPages);

  const handlePageChange = (page: number) => {
    if (page === currentPage || page < 1 || page > totalPages) {
      return;
    }
    onPageChange(page);
  };

  return (
    <div className="d-lg-flex align-items-center text-center pb-1 mt-3">
      <span className="me-3">
        Page{" "}
        <strong>
          {currentPage} of {totalPages}
        </strong>{" "}
        | Total Items: <strong>{totalItems}</strong>
      </span>

      {/* <span className="d-inline-block align-items-center text-sm-start text-center my-sm-0 my-2">
        <label className="form-label">Go to page : </label>
        <input
          type="number"
          value={currentPage}
          min="1"
          max={totalPages}
          onChange={(e: any) => {
            const page = e.target.value ? Number(e.target.value) : 1;
            handlePageChange(page);
          }}
          className="form-control w-25 ms-1 d-inline-block"
        />
      </span> */}

      <ul className="pagination pagination-rounded d-inline-flex ms-auto align-item-center mb-0">
        <li
          key="prevpage"
          className={classNames("page-item", "paginate_button", "previous", {
            disabled: !hasPreviousPage,
          })}
          onClick={() => {
            if (hasPreviousPage) {
              handlePageChange(currentPage - 1);
            }
          }}
        >
          <Link to="#" className="page-link">
            <i className="mdi mdi-chevron-left"></i>
          </Link>
        </li>
        {(visiblePages || []).map((page, index, array) => {
          return array[index - 1] + 1 < page ? (
            <React.Fragment key={page}>
              <li className="page-item disabled d-none d-xl-inline-block">
                <Link to="#" className="page-link">
                  ...
                </Link>
              </li>
              <li
                className={classNames("page-item", "d-none", "d-xl-inline-block", {
                  active: currentPage === page,
                })}
                onClick={() => handlePageChange(page)}
              >
                <Link to="#" className="page-link">
                  {page}
                </Link>
              </li>
            </React.Fragment>
          ) : (
            <li
              key={page}
              className={classNames("page-item", "d-none", "d-xl-inline-block", {
                active: currentPage === page,
              })}
              onClick={() => handlePageChange(page)}
            >
              <Link to="#" className="page-link">
                {page}
              </Link>
            </li>
          );
        })}
        <li
          key="nextpage"
          className={classNames("page-item", "paginate_button", "next", {
            disabled: !hasNextPage,
          })}
          onClick={() => {
            if (hasNextPage) {
              handlePageChange(currentPage + 1);
            }
          }}
        >
          <Link to="#" className="page-link">
            <i className="mdi mdi-chevron-right"></i>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default ApiPagination;
